import { chakra } from "@chakra-ui/react";
import React, { Component } from "react";

const MAX_PIXEL_SIZE = 96;
const EnhancedVideo = chakra("video");

export default class SeeMeVideoPreview extends Component {
  videoRef = React.createRef();

  componentDidMount = () => {
    const { localVideoStream } = this.props;

    if (this.videoRef.current == null) return;
    if (this.videoRef.current.srcObject !== localVideoStream) {
      this.videoRef.current.srcObject = localVideoStream;
    }
  };

  componentDidUpdate() {
    const { localVideoStream } = this.props;

    if (this.videoRef.current == null) return;
    if (this.videoRef.current.srcObject !== localVideoStream) {
      this.videoRef.current.srcObject = localVideoStream;
    }
  }

  render() {
    const { remotePreviewAspectRatio } = this.props;
    let height, width;

    if (remotePreviewAspectRatio <= 1) {
      height = MAX_PIXEL_SIZE;
      width = MAX_PIXEL_SIZE * remotePreviewAspectRatio;
    } else {
      height = MAX_PIXEL_SIZE / remotePreviewAspectRatio;
      width = MAX_PIXEL_SIZE;
    }

    return (
      <EnhancedVideo
        sx={{
          width: `${width}px`,
          height: `${height}px`
        }}
        style={{
          borderRadius: "12px",
          background: "black",
          objectFit: "cover"
        }}
        ref={this.videoRef}
        autoPlay
        muted
      />
    );
  }
}
